export default __webpack_public_path__ + "5cf7ba2.png";